import { BaseApi } from '../BaseApi'
import { SplashScreenResult } from './types'

export class SplashScreenApi {
  public static async load() {
    return BaseApi.authenticatedCall()
      .url('v1/mobile/splashscreen')
      .get()
      .json(json => json) as Promise<SplashScreenResult>
  }
}
